import { DDDFreespinResultPresentation } from "../freespin/DDDFreespinResultPresentation";

export class DDDSuperFreespinResultPresentation extends DDDFreespinResultPresentation {
    constructor() {
        super(`DDDSuperFreespinResultPresentation`);
    }
}
